var _defs, _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10002IconServiceSubscriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bc18bade-5481-447e-a959-659d72346474",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a445c717-9d75-44c7-ba6b-0d8f2383e560",
    cx: -36.63,
    cy: 17.12,
    r: 11.18,
    gradientTransform: "translate(41.88 -7.4) scale(0.94 0.94)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#ffd70f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#ffcb12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#feac19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea11b"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-general-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e3d1e58c-f78e-4fb5-9857-0c9331da9979",
    d: "M13.56,7.19a2.07,2.07,0,0,0,0-2.93h0L10,.69a2.06,2.06,0,0,0-2.92,0h0L3.52,4.26a2.09,2.09,0,0,0,0,2.93l3,3a.61.61,0,0,1,.17.41v5.52a.7.7,0,0,0,.2.5l1.35,1.35a.45.45,0,0,0,.66,0l1.31-1.31h0l.77-.77a.26.26,0,0,0,0-.38l-.55-.56a.29.29,0,0,1,0-.42l.55-.56a.26.26,0,0,0,0-.38L10.4,13a.28.28,0,0,1,0-.41L11,12a.26.26,0,0,0,0-.38l-.77-.78v-.28Zm-5-5.64A1.18,1.18,0,1,1,7.37,2.73,1.17,1.17,0,0,1,8.54,1.55Z",
    fill: "url(#a445c717-9d75-44c7-ba6b-0d8f2383e560)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a21a8f7a-61cc-4035-8449-e5c8fe4d4d5e",
    d: "M7.62,16.21h0A.25.25,0,0,0,8,16V11.55a.27.27,0,0,0-.11-.22h0a.25.25,0,0,0-.39.22V16A.27.27,0,0,0,7.62,16.21Z",
    fill: "#ff9300",
    opacity: 0.75
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "ecd3189c-fb1e-4a0e-a2b6-ba2f11dda484",
    x: 5.69,
    y: 5.45,
    width: 5.86,
    height: 0.69,
    rx: 0.32,
    fill: "#ff9300",
    opacity: 0.75
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "a1949a3c-4818-4bd1-b236-0d970b92fc62",
    x: 5.69,
    y: 6.57,
    width: 5.86,
    height: 0.69,
    rx: 0.32,
    fill: "#ff9300",
    opacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10002IconServiceSubscriptions);
export default __webpack_public_path__ + "static/media/10002-icon-service-Subscriptions.3bfe595264cb9e731358a2b64b41cc00.svg";
export { ForwardRef as ReactComponent };